import { css } from 'linaria';

export const reelModalModal = css`
  && {
    max-width: 796px;

    @media (--only-desktop) {
      max-width: 768px;
    }

    @media (--only-tablet) {
      max-width: 544px;
    }

    @media (--only-mobile) {
      max-width: 100%;
      border-radius: 0;
    }
  }
`;

export const reelModalModalСlose = css`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
`;

export const reelModalVideo = css`
  height: 446px;
  object-fit: cover;
  object-position: bottom;

  @media (--only-desktop) {
    height: 430px;
  }

  @media (--only-tablet) {
    height: 304px;
  }

  @media (--only-mobile) {
    height: 55.62vw;
  }
`;
